import React, { useState } from "react";
import { SlidingCubeLoader } from "react-loaders-kit";
import useAuthStore from "../../../../store/useAuthStore";
import DateRange from "../DateRange";
import ParentCF from "./ParentCF";

const CashFlow = () => {
  const [comparisonData, setComparisonData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const [cashFlow, setCashFlow] = useState({ inflow: 0, outflow: 0, net: 0 });

  const { token } = useAuthStore();

  const calculateCashFlow = (data) => {
    let inflow = 0;
    let outflow = 0;

    data.forEach((item) => {
      if (item.type === "income") {
        inflow += item.amount;
      } else if (item.type === "expense") {
        outflow += item.amount;
      }
    });

    const net = inflow - outflow;
    setCashFlow({ inflow, outflow, net });
  };

  const handleFilteredDataChange = async ({ ranges }) => {
    setLoading(true);
    try {
      const fetchOptions = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Get the overall combined data for simple summary cards if needed
      // but mostly we need it for comparisonData
      const comparisonData = await Promise.all(
        ranges.map(async (range) => {
          const startDate = range.startDate.toISOString().split("T")[0];
          const endDate = range.endDate.toISOString().split("T")[0];

          const incomeResponse = await fetch(
            `/api/getallIncomes?startDate=${startDate}&endDate=${endDate}&limit=-1`,
            fetchOptions
          );
          const expenseResponse = await fetch(
            `/api/getallexpense?startDate=${startDate}&endDate=${endDate}&limit=-1`,
            fetchOptions
          );

          if (!incomeResponse.ok || !expenseResponse.ok) {
            throw new Error("Failed to fetch data");
          }

          const incomeResult = await incomeResponse.json();
          const expenseResult = await expenseResponse.json();

          const periodData = [
            ...incomeResult.incomes.map((income) => ({ ...income, type: "income" })),
            ...expenseResult.expenses.map((expense) => ({ ...expense, type: "expense" })),
          ];

          return {
            period: [range.startDate, range.endDate],
            data: periodData,
          };
        })
      );

      setComparisonData(comparisonData);

      // Use the first range's data for the quick summary cards
      if (comparisonData.length > 0) {
        calculateCashFlow(comparisonData[0].data);
      }

      setError("");
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error updating Cash Flow report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div className="text-center text-red-500">{error}</div>;
  }

  return (
    <div>
      <DateRange
        onFilteredDataChange={handleFilteredDataChange}
      />
      {loading ? (
        <div className="flex justify-center items-center min-h-screen">
          <SlidingCubeLoader
            loading={true}
            size={50}
            colors={["#2887D4BE", "#0976C3BE"]}
            duration={1}
          />
        </div>
      ) : (
        <>
          <ParentCF comparisonData={comparisonData} />
          <div className="mt-8 p-4 bg-gray-100 rounded shadow-lg">
            <div className="mt-4">
              <p className="text-gray-600">
                <strong>Total Inflow:</strong> Nu. {cashFlow.inflow.toLocaleString()}
              </p>
              <p className="text-gray-600">
                <strong>Total Outflow:</strong> Nu. {cashFlow.outflow.toLocaleString()}
              </p>
              <p className={`text-lg font-bold ${cashFlow.net >= 0 ? "text-green-600" : "text-red-600"}`}>
                <strong>Net Cash Flow:</strong> Nu. {cashFlow.net.toLocaleString()}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CashFlow;
